/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Set_Voice_Channel_StatusInputs */



/**
* | output |
* | --- |
* | "Set Voice Channel Status" |
*
* @param {Leveling_Perm_Set_Voice_Channel_StatusInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_set_voice_channel_status = /** @type {((inputs?: Leveling_Perm_Set_Voice_Channel_StatusInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Set_Voice_Channel_StatusInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Устанавливать статус голосового канала")
	return /** @type {LocalizedString} */ ("Set Voice Channel Status")
});